import { getUser } from './http';

export interface Module {
  id: number;
  name: string;
  table_name: string;
  description?: string;
  order?: number;
  list_field_id?: number | null;
  sort_field_id?: number | null;
  [key: string]: any;
}

export const modulesApi = {
  async getAll(): Promise<Module[]> {
    try {
      const response = await getUser('settings/menu-settings');
      return response.modules || [];
    } catch (error) {
      return [];
    }
  },

  async getByName(moduleName: string): Promise<Module | null> {
    try {
      const modules = await this.getAll();

      const module = modules.find(
        m => m.name?.toLowerCase() === moduleName.toLowerCase()
      );

      return module || null;
    } catch (error) {
      console.error(`Failed to find module "${moduleName}":`, error);
      return null;
    }
  },

  async getIdByName(moduleName: string): Promise<number | null> {
    const module = await this.getByName(moduleName);
    return module?.id || null;
  },

  async getTableNameByName(moduleName: string): Promise<string | null> {
    const module = await this.getByName(moduleName);
    return module?.table_name || null;
  },
};